import { Location, NavigateFunction } from "react-router-dom";
import { sendEventTracking } from "../../utils/GeneralUtils";

export type SearchParam = { field: string; value: string | Array<string> };

const updateParam = (
  query: URLSearchParams,
  field: string,
  value: string | Array<string>
) => {
  query.delete(field);

  if (value === "") return;

  if (typeof value === "string") {
    if (value.length) query.set(field, value);
  } else {
    value.map((el) => {
      query.append(field, el);
    });
  }
};

const updatePageParam = (query: URLSearchParams, value: string) => {
  query.delete("pg");

  if (value !== "1") {
    query.append("pg", value);
  }
};

export const getParam = (query: URLSearchParams, field: string) => {
  const param = query.get(field);
  return param !== null ? param : undefined;
};

export const getParamAll = (query: URLSearchParams, field: string) => {
  return query.getAll(field);
};

export const searchHandler = (
  query: URLSearchParams,
  params: Array<SearchParam>,
  navigateFunc: NavigateFunction
) => {
  params.forEach((param) => {
    updateParam(query, param.field, param.value);
  });
  updatePageParam(query, "1");

  navigateFunc({ search: query.toString() });
};

export const searchClearHandler = (navigateFunc: NavigateFunction) => {
  navigateFunc({ search: "" });
};

export const getCurrentPage = (query: URLSearchParams) => {
  const pg = Number(query.get("pg"));

  return Number.isInteger(pg) && pg > 0 ? pg : 1;
};

export const handlePage = (
  query: URLSearchParams,
  value: number,
  navigateFunc: NavigateFunction
) => {
  updatePageParam(query, value.toString());
  navigateFunc({ search: query.toString() });
};

export const getCurrentPerView = (query: URLSearchParams) => {
  const per = Number(query.get("per"));

  return Number.isInteger(per) && per > 0 ? per : 12;
};

export const handlePerView = (
  query: URLSearchParams,
  location: Location,
  navigateFunc: NavigateFunction,
  value: number
) => {
  updateParam(query, "per", value.toString());
  updatePageParam(query, "1");

  sendEventTracking(
    "click",
    `${location.pathname.split("/")[1]}List`,
    value.toString()
  );

  navigateFunc({ search: query.toString() });
};

export const checkParamExist = (
  query: URLSearchParams,
  paramKeys: Array<string>
) => {
  let result: boolean = false;

  for (let i = 0; i < paramKeys.length; i++) {
    if (query.get(paramKeys[i]) !== null) {
      result = true;
      break;
    }
  }

  return result;
};
